export default __webpack_public_path__ + "static/media/hbd.7c1e3f07.png";